export default __webpack_public_path__ + "static/media/userleaved.00110b23.mp3";